import { RootState } from '../store'

export const selectedMetaData = (state: RootState) => state.meta
